





























































































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindClienteUseCase, SaveClienteUseCase } from '@/usecases'
import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator'
import { obrigatorio, maiorOuIgualAZero } from '@/shareds/regras-de-form'
import SeletorDeTipoDeCliente from '@/components/tabeladepreco/SeletorDeTipoDeCliente.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { TipoDeOperacao } from '@/models/Recurso'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import { nextTick } from '@/shareds/utils'
import SeletorDeUsuario from '../usuario/SeletorDeUsuario.vue'
import ListagemDeLojaPorCliente from '../loja/ListagemDeLojaPorCliente.vue'
import ListagemDosGruposEconomicosPorCliente from './ListagemDosGruposEconomicosPorCliente.vue'
import { FindLojaUseCase } from '@/usecases'
import { TipoDePagamento } from '@/models'
import { ClienteService } from '@/services'
import Confirmacao from '../ui/Confirmacao.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'

type AbaDoCliente = 'Bloquear' | 'Liberar'

@Component({
	components: {
		SeletorDeTipoDeCliente,
		SeletorDeUsuario,
		ListagemDeLojaPorCliente,
		ListagemDosGruposEconomicosPorCliente,
		Confirmacao,
		SeletorDeLojasDoUsuario,
	},
})
export default class DialogoDeEditarTiposDePagamentoDeCliente extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() confirmaAlteracoes!: Confirmacao
	@Prop({ type: String }) idDoCliente!: string
	
	salvando = false
	mostra = false
	saveClienteUseCase = new SaveClienteUseCase()
	findClienteUseCase = new FindClienteUseCase()
	clienteService = new ClienteService()
	obrigatorio = obrigatorio
	maiorOuIgualAZero = maiorOuIgualAZero
	tabs: AbaDoCliente[] = ['Bloquear', 'Liberar']
	tab: null | number = null

	findLojaUseCase = new FindLojaUseCase()
	bloquearTiposDePagamento = false
	liberarTiposDePagamento = false
	lojaId = ''
	tiposDePagamentos: TipoDePagamento[] = []
	tiposDePagamentoSelecionados: string[] = []
	carregando = false
	cliente = ''

	get abasPermitidas() {
		return this.tabs
			.filter(aba => {
				if (aba !== 'Bloquear') return true
				return UserLoginStore.permiteRegraDeNegocio('pode-alterar-bloqueios-de-cliente')
			})
			.filter(aba => {
				if (aba !== 'Liberar') return true
				return UserLoginStore.permiteRegraDeNegocio('pode-alterar-bloqueios-de-cliente')
			})
	}

	get podeAlterarCliente() {
		return this.podeRealizarOperacao('alterar')
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return !'clientes' || UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'clientes'))
	}

	mostrar() {
		this.mostra = true
		this.cliente = this.idDoCliente
	}

	esconder() {
		this.mostra = false
		this.lojaId = ''
		this.liberarTiposDePagamento = false
		this.bloquearTiposDePagamento = false
	}

	async salvar() {
		await nextTick()
		if (!this.cliente) return
		try {
			this.salvando = true

			const clienteSalvo = await this.clienteService.alterarBloqueioDeTipoDePagamentoClienteByFiltro(this.cliente, this.lojaId, this.bloquearTiposDePagamento, this.liberarTiposDePagamento, this.tiposDePagamentoSelecionados)
			this.$emit('confirmado', clienteSalvo)
			this.$emit('clienteAtualizado')
			this.mostra = false
			AlertModule.setSuccess('Alterações realizadas com sucesso.')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.tiposDePagamentoSelecionados = []
			this.bloquearTiposDePagamento = false
			this.liberarTiposDePagamento = false
			this.lojaId = ''
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if(mostra) return
		this.cliente = this.idDoCliente
	}	

	async buscaTiposDePagamentoLoja(){
		const loja = await this.findLojaUseCase.findLojaById(this.lojaId)
		this.tiposDePagamentos = loja.tiposDePagamento
	}

	handleBloquearChange(){
		if(this.bloquearTiposDePagamento){
			this.liberarTiposDePagamento = false;
			this.tiposDePagamentoSelecionados = [];
		}
	}

	handleLiberarChange(){
		if(this.liberarTiposDePagamento){
			this.bloquearTiposDePagamento = false;
			this.tiposDePagamentoSelecionados = [];
		}
	}

	abrirDialogoDeConfirmacao(){
		this.confirmaAlteracoes.mostrar()
	}

	@Watch('lojaId')
	async onLojaIdChange(lojaId: string) {
		if (lojaId) {
			await this.buscaTiposDePagamentoLoja()
		}
		else {
			this.lojaId = ''
		}
	}
}
